import { render, staticRenderFns } from "./ProductCustomTag.vue?vue&type=template&id=e603aef8&scoped=true&"
import script from "./ProductCustomTag.vue?vue&type=script&lang=ts&"
export * from "./ProductCustomTag.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCustomTag.vue?vue&type=style&index=0&id=e603aef8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e603aef8",
  null
  
)

export default component.exports